import { IxFileChip } from './IxFileChip.js';

customElements.define('ix-file-chip', IxFileChip);
